import { createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk';
import * as conversation from '@alme/ui-web/ref/lib-alme-request';

import { setupComponents } from './setup-components';
import { setupReducers } from './setup-reducers';
import { setupState } from './setup-state';

export default class AlmeWebClient {
    constructor() {
        const components = setupComponents(conversation);
        this._components = components.components;
        this._initialization = components.initialization;
    }

    initialize() {
        const middlewares = [];
        middlewares.push(thunk);

        // set up redux extension
        const composeEnhancers = composeWithDevTools({
            maxAge: 500,
            actionsBlacklist: [
                'PERSIST_STATE_CHANGE',
                'REFRESH_PERSISTED_STATE',
                'SET_INACTIVITY_TIME',
                'UPDATE_CURRENT_INPUT',
            ],
        });

        this._store = createStore(setupReducers(this._components, this._initialization), setupState(this._components),
            composeEnhancers(applyMiddleware(...middlewares)));

        // Call initialize on all components using the store
        const initializePromises = this._initialization.initialize(this._store);

        Object.keys(this._components).forEach((comp) => {
            if (this._components[comp].initialize) {
                this._components[comp].initialize(this._store, initializePromises);
            }
        });

        this._components.chatSurveyOverlay.initializePanes(this._store);

        conversation.setStore(this._store);
    }

    start() {
        // Use the initialize module to set the initialization state locations
        this._initialization.startApplicationInitialize();
    }
}



// WEBPACK FOOTER //
// ./src/client.js